import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const StatsContext = createContext({ stats: {}, ready: false });

export const StatsProvider = ({ children }) => {
  const [stats, setStats] = useState({});
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let live = true;
    axios
      .get(`${API}/stats/products`)
      .then((res) => {
        if (live) {
          setStats(res.data || {});
          setReady(true);
        }
      })
      .catch(() => {
        if (live) setReady(true);
      });
    return () => {
      live = false;
    };
  }, []);

  return (
    <StatsContext.Provider value={{ stats, ready }}>
      {children}
    </StatsContext.Provider>
  );
};

export const useProductStats = (slug) => {
  const { stats, ready } = useContext(StatsContext);
  return { stat: stats[slug], ready };
};

export const useAllStats = () => useContext(StatsContext);
